import { useMutation } from "@tanstack/react-query";
import { sendDemoRequest } from "@/api/email";
import { toast } from "sonner";

/**
 * Hook for demo request submission
 *
 * @returns {Object} TanStack Query mutation object
 */
export const useDemoRequest = () => {
  return useMutation({
    mutationFn: (formData) => sendDemoRequest(formData),
    onError: (error) => {
      const errorMessage =
        error.response?.data?.message || error.message || "Failed to submit demo request";
      console.error("Demo request error:", errorMessage);

      toast.error("Failed to submit request", {
        description: errorMessage,
        duration: 5000,
      });
    },
  });
};
